import API from "../../common/utils/API";
import {displayDebugFiles, displayTxLogs} from "../../support/actions/supportActions";
import {SupportActionTypes} from "../../support/actions/SupportActionConstants";

/**
 * This is the Middleware to get the transaction logs and debug files.
 * @param store, action
 * @returns Makes the call to the Marvel API which fetches data from S3
 *          and returns it to display in the modal.
  */
const txDebugLogsMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case SupportActionTypes.GET_TX_LOGS: {
            next(action);

            const { authToken, wsid } = action.payload;
            let txLogsData = null;

            API.getTransactionLogs(authToken.idToken, wsid)
                .then(resTxLogs => {
                    txLogsData = resTxLogs.data;
                    setTimeout(() => {
                        store.dispatch(displayTxLogs(txLogsData))
                    }, 600);
                }).catch(err => {
                    console.error(err)
                // this action is dispatched for a condition where the requested WSID
                // does not have any tx-log but has associated debug files which the
                // user might want to look up.
                    store.dispatch(displayTxLogs(err.error))
                });

            break;
        }

        case SupportActionTypes.GET_DEBUG_FILES: {
            next(action);

            const { authToken, wsid } = action.payload;
            let debugFilesData = null;

            API.getDebugFiles(authToken.idToken, wsid)
                .then(resDebugFiles => {
                    debugFilesData = resDebugFiles.data;
                    // only dispatch action if a debug logs are available
                    setTimeout(() => {
                        store.dispatch(displayDebugFiles(debugFilesData))
                    }, 1000);
                }).catch(err => console.error(err));
            break;
        }

        default: next(action)
    }
}


export default txDebugLogsMiddleware;
